window.addEventListener('load', function () {
  const cmpnt = document.querySelector('.pricing_plans');
  const priceContainers = cmpnt.querySelectorAll('.plan-price');
  const radios = cmpnt.querySelectorAll('.pricing_plans-nav input[type="radio"]');

  let data = {
    currency: cmpnt.getAttribute('data-currency'),
    billingPeriod: cmpnt.getAttribute('data-current-term'),
    billingString1: cmpnt.getAttribute('data-billing-1'),
    billingString12: cmpnt.getAttribute('data-billing-12'),
  };

  function updateBillingPeriod(period) { data.billingPeriod = period };
  function updatePrices() {
    priceContainers.forEach(container => {
      const pricingValue = container.querySelector('.plan-price_value');
      const pricingTerm = container.querySelector('.plan-price_term');   
      const price = pricingValue.getAttribute(`data-billing-${data.billingPeriod}`);
      const isCustom = price === "Custom";

      pricingValue.innerText = isCustom ? price : `${data.currency}${price}`;
      pricingTerm.innerText = isCustom ? "" : data[`billingString${data.billingPeriod}`];
    });
  };

  // Setup handler for changing the billing period between monthly/annual
  radios.forEach(radio => {
    radio.addEventListener('click', function () {
      updateBillingPeriod(this.value);
      updatePrices();
    });
  });

  updatePrices();
});
